/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `A1` - A1
* `A2` - A2
* `B1` - B1
* `B2` - B2
* `C1` - C1
* `C2` - C2
 */
export type LevelEnum = typeof LevelEnum[keyof typeof LevelEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LevelEnum = {
  A1: 'A1',
  A2: 'A2',
  B1: 'B1',
  B2: 'B2',
  C1: 'C1',
  C2: 'C2',
} as const;
